var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hasCategories
    ? _c("tbody", [
        _c("tr", [
          _c("th", [
            _c("label", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.label) + ":"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c(
                "multiselect",
                {
                  staticClass: "is-shorter",
                  attrs: { options: _vm.options, taggable: true, multiple: "" },
                  on: {
                    tag: (newTag) => {
                      _vm.value.push(newTag)
                    },
                  },
                  model: {
                    value: _vm.tags,
                    callback: function ($$v) {
                      _vm.tags = $$v
                    },
                    expression: "tags",
                  },
                },
                [_c("span", { attrs: { slot: "caret" }, slot: "caret" })]
              ),
              _vm._v(" "),
              _vm.errors
                ? _c("p", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.errors)),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ])
    : _c(
        "tbody",
        { staticClass: "tag-category-rows" },
        [
          _vm._l(_vm.sortedCategories, function (category) {
            return _c("tr", { key: "tagcat" + category.id }, [
              _c("th", [
                _c("label", { staticClass: "label" }, [
                  _vm._v("\n                " + _vm._s(category.name)),
                  category.mandatory
                    ? _c("span", { staticClass: "has-text-danger" }, [
                        _vm._v("*"),
                      ])
                    : _vm._e(),
                  _vm._v(":\n            "),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "multiselect",
                    {
                      staticClass: "is-shorter",
                      attrs: {
                        options: category.valueList || [],
                        multiple: category.multiple,
                        value: _vm.categoryValue(category),
                        placeholder: "Tag wählen",
                      },
                      on: {
                        input: (input) => _vm.setCategoryValue(category, input),
                      },
                    },
                    [_c("span", { attrs: { slot: "caret" }, slot: "caret" })]
                  ),
                ],
                1
              ),
            ])
          }),
          _vm._v(" "),
          _c("tr", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "td",
              [
                _c(
                  "multiselect",
                  {
                    staticClass: "is-shorter",
                    attrs: {
                      options: [],
                      value: _vm.uncategorizedValue,
                      taggable: true,
                      multiple: "",
                      placeholder: "Freien Tag hinzufügen",
                    },
                    on: {
                      tag: (newTag) => {
                        _vm.value.push(newTag)
                      },
                      input: (input) => _vm.setUncategorizedValue(input),
                    },
                  },
                  [_c("span", { attrs: { slot: "caret" }, slot: "caret" })]
                ),
                _vm._v(" "),
                _vm.errors
                  ? _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.errors)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        2
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", [_c("label", { staticClass: "label" }, [_vm._v("Tags:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }